import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { IMAGES } from "@/lib/images";
import { ArrowRight } from "lucide-react";
import Reviews from "@/components/Reviews";
import Countdown from "@/components/Countdown";

function Door({ img, overline, title, desc, cta, to, testid, tint }) {
  const navigate = useNavigate();
  return (
    <motion.div
      data-testid={testid}
      onClick={() => navigate(to)}
      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
      whileHover="hover"
      className="group relative flex-1 min-h-[62vh] md:min-h-screen overflow-hidden cursor-pointer"
    >
      <motion.div
        variants={{ hover: { scale: 1.06 } }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${img})` }}
      />
      <div className="absolute inset-0" style={{ background: tint }} />
      <div className="absolute inset-0 vignette" />
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.div
          initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <p className="overline mb-4">{overline}</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mb-4 sm:mb-5 text-[#FBF8F5] tracking-tight">{title}</h2>
          <p className="text-sm sm:text-base text-[#D8D2CE] max-w-sm mx-auto leading-relaxed mb-6 sm:mb-8 px-2">{desc}</p>
          <span className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-[#D4AF37]/50 text-[#F3E5AB] font-semibold tracking-wide bg-black/30 group-hover:bg-[#D4AF37] group-hover:text-black transition-all duration-500">
            {cta} <ArrowRight className="w-4 h-4" />
          </span>
        </motion.div>
      </div>
    </motion.div>
  );
}

export default function Portal() {
  return (
    <div className="bg-[#0B0A0C]">
      <div className="relative md:min-h-screen">
      <div className="relative md:absolute md:top-0 md:inset-x-0 z-20 pt-6 pb-5 md:pb-4 text-center md:pointer-events-none bg-[#0B0A0C] md:bg-transparent">
        <a href="https://www.annunci69.it/clubprive/bari/Afrodite-Club-Prive-Puglia/80/" target="_blank" rel="noopener noreferrer" className="pointer-events-auto inline-flex flex-col items-center">
          <img
            src={IMAGES.logo}
            alt="Afrodite Club Privé & Spa Naturista"
            data-testid="portal-logo"
            className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border border-[#D4AF37]/50 shadow-[0_0_40px_rgba(212,175,55,0.25)] mb-3"
          />
          <span className="font-display text-3xl sm:text-4xl tracking-[0.2em] gold-text">AFRODITE</span>
          <p className="text-[0.6rem] tracking-[0.35em] text-[#A39E9B] uppercase mt-1">Club Privé &amp; Spa Naturista · Puglia</p>
        </a>
      </div>

      <div className="flex flex-col md:flex-row md:min-h-screen">
        <Door
          testid="portal-club-door-btn"
          img={IMAGES.hero_club}
          overline="Le Notti"
          title="Club Privé"
          desc="Eventi, serate a tema e atmosfere trasgressive tra luci soffuse, musica e la massima discrezione."
          cta="Entra nel Club Privé"
          to="/club-prive"
          tint="linear-gradient(180deg, rgba(11,10,12,0.35) 0%, rgba(74,11,23,0.55) 60%, rgba(11,10,12,0.85) 100%)"
        />
        <div className="hidden md:block w-px bg-[#D4AF37]/25" />
        <Door
          testid="portal-spa-door-btn"
          img={IMAGES.hero_spa}
          overline="Il Benessere"
          title="Spa Naturista"
          desc="Relax e rigenerazione: sauna, idromassaggio, rituali e massaggi in un'oasi naturista di puro benessere."
          cta="Esplora la Spa"
          to="/spa-naturista"
          tint="linear-gradient(180deg, rgba(11,10,12,0.35) 0%, rgba(102,70,30,0.45) 60%, rgba(11,10,12,0.85) 100%)"
        />
      </div>

      <div className="relative md:absolute md:bottom-6 md:inset-x-0 z-20 flex flex-col items-center gap-5 px-4 py-8 md:py-0 bg-[#0B0A0C] md:bg-transparent">
        <Countdown />
        <Link to="/contatti" className="text-xs text-[#6E6865] hover:text-[#D4AF37] tracking-widest uppercase">
          Informazioni &amp; Contatti
        </Link>
      </div>
      </div>
      <Reviews dark />
    </div>
  );
}
